import React, { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { timestampToDateFull } from "../../helper/helper.jsx";

function PricinghistoryList(props) {
  const [list, setList] = useState([]);

  useEffect(() => {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      if (!user) {
        return props.history.replace("/login");
      }
    });

    if (props.location.state === undefined) {
      return props.history.replace("/home");
    }
    setList(props.location.state.history);
  }, []);

  return (
    <div className="table-design">
      <div className="row">
        <div className="col-md-12">
          <table className="table">
            <thead>
              <tr>
                <th>Time</th>
                <th>Walking base</th>
                <th>Cycling Base</th>
                <th>Riding Base</th>
                <th>Change note</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(list)
                .sort(([a], [b]) => b - a)
                .map(([key, value]) => (
                  <tr key={key}>
                    <td>{timestampToDateFull(key)}</td>
                    <td>{value.walking_base_fare}</td>
                    <td>{value.cycling_base_fare}</td>
                    <td>{value.riding_base_fare}</td>
                    <td>{value.change_note}</td>
                    <td>
                      <button
                        className="search-view"
                        onClick={() => {
                          props.history.push(
                            "/home/pricingObject/history/single",
                            {
                              key: key,
                              value: value,
                            }
                          );
                        }}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PricinghistoryList;
